import { partnerCategories as staticPartnerCategories } from "./partnerCategories";

const hoverTemplates = [
  (label) => `Certified ${label} partner delivering enterprise integration and support.`,
  (label) => `Authorized ${label} alliance for secure scalable business solutions.`,
  (label) => `Strategic ${label} collaboration enabling trusted digital transformation.`,
  (label) => `Premier ${label} vendor partnership for modern infrastructure needs.`,
  (label) => `Trusted ${label} technology partner for end to end deployments.`,
];

function logoInfo(logo, categoryLabel, index) {
  if (typeof logo === "string") {
    return {
      file: logo,
      name: categoryLabel,
      hoverText: hoverTemplates[index % hoverTemplates.length](categoryLabel),
    };
  }
  const name = logo.name ?? categoryLabel;
  return {
    file: logo.file ?? null,
    name,
    hoverText: logo.hoverText ?? `Authorized ${name} partner for ${categoryLabel} solutions.`,
  };
}

export const DEFAULT_PARTNERS_PAGE = {
  heroLabel: "Technology Partners",
  heroTitleBefore: "Authorized partners powering",
  heroTitleAccent: "your stack.",
  heroDesc:
    "We collaborate with industry-leading vendors across cybersecurity, networking, cloud, and infrastructure — so you get proven technology with expert integration.",
  introLabel: "Strategic Alliances",
  introTitle: "Best-in-class technology, delivered together",
  introText1:
    "Our partnerships with global technology leaders enable us to design, deploy, and support solutions that meet enterprise standards for performance, security, and scale.",
  introText2:
    "Hover any partner logo to learn more about the alliance and capability it brings to your project.",
  introImage: "/img/partners-section.jpg",
  ctaTitle: "Need the right technology partner for your project?",
  ctaDesc: "Talk to our team about certified integrations, licensing, and deployment support.",
  ctaButton: "Contact Us",
};

/** Build CMS seed from existing static partner logo folders. */
export function buildPartnersSeed() {
  const partnerCategories = [];
  const partners = [];

  staticPartnerCategories.forEach((cat, ci) => {
    const catId = `pcat-${cat.id}`;
    partnerCategories.push({
      id: catId,
      name: cat.label,
      slug: cat.id,
      folder: cat.folder || "",
      sortOrder: ci,
    });

    (cat.logos || []).forEach((logo, li) => {
      const info = logoInfo(logo, cat.label, li);
      const image =
        info.file && cat.folder
          ? `/img/${cat.folder}/${info.file}`
          : "";
      partners.push({
        id: `partner-${cat.id}-${li}`,
        categoryId: catId,
        name: info.name,
        image,
        link: "",
        hoverText: info.hoverText,
        sortOrder: li,
        status: "active",
      });
    });
  });

  return {
    partnersPage: { ...DEFAULT_PARTNERS_PAGE },
    partnerCategories,
    partners,
  };
}
